import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';

const Role = ({
    registrationIdsSelected,
    isActiveFilter
}) => {
    const [idItem, setIdItem] = useState(null);
    const [dsRole, setDsRole] = useState(null);
    const [isActive, setIsActive] = useState('S');
    const [username, setUsername] = useState(null);
    const [dtUpdate, setDtUpdate] = useState(null);

    const [inserting, setInserting] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [loadingItemPanel, setLoadingItemPanel] = useState(null);
    const [recordsItemByUserId, setRecordsItemByUserId] = useState(null);
    const [attributesDetailItemPanel, setAttributesDetailItemPanel] = useState(null);
    const [rolesIdSelected, setRolesIdSelected] = useState([]);

    const readOnlyAttributes = !(inserting || updating);

    const attributeList = [
        { name: "id", value: idItem, setter: setIdItem },
        { name: "role", value: dsRole, setter: setDsRole },
        {
            name: "isActive", value: isActive, setter: setIsActive, resetValue: 'S', readOnlyGrid: true,
            checks: [
                { field: 'isActive', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        { name: "usernameUpdate", value: username, setter: setUsername },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate }
    ];

    useEffect(() => {
        setInserting(false)
        setUpdating(false)
        setRolesIdSelected([])
    }, [isActiveFilter]);

    useEffect(() => {
        reloadListItem()
    }, [registrationIdsSelected, isActiveFilter])

    useEffect(() => {
        if (rolesIdSelected && rolesIdSelected.length === 1) {
            fetchDataDetail(rolesIdSelected[0]);
        } else {
            fetchDataDetail(null);
        }
    }, [rolesIdSelected]);

    const itemPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '83%'
    };

    async function reloadListItem() {
        const parameters = { onlyActive: isActiveFilter }
        const items = await ExecuteAxios.api('get', `/role/get-role-grid/`, { params: parameters });
        setRecordsItemByUserId(items);
        RemoveIdsNotFound.remove(items, setRolesIdSelected, rolesIdSelected)
    }

    const fetchDataDetail = async (rolesIdSelected) => {
        const parameters = { id: rolesIdSelected ? rolesIdSelected : 0 }
        const item = await ExecuteAxios.api('get', `/role/get-role-detail/`, { params: parameters })
        if (item) {
            setAttributesDetailItemPanel(item)
            ApplyAttributes.applyAttributes(item, attributeList)
        }

        if (!rolesIdSelected) {
            ResetVariables.resetVariables(attributeList)
        }
    };

    const getItemPanelListOrDetail = () => {
        if (!updating && !inserting) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={setRolesIdSelected}
                    idsSelected={rolesIdSelected}
                    data={recordsItemByUserId}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailItemPanel}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function postItem() {
        try {
            setLoadingItemPanel(true)
            const response = await ExecuteAxios.api('post', `/role/`, {
                role: dsRole,
                isActive: isActive
            });
            if (response) {
                await reloadListItem()
            }
            return response
        } finally {
            setLoadingItemPanel(false)
        }
    }

    async function putItem() {
        try {
            setLoadingItemPanel(true)
            const response = await ExecuteAxios.api('put', `/role/`, {
                id: idItem,
                role: dsRole,
                isActive: isActive
            });

            if (response) {
                await reloadListItem()
            }

            return response;
        } finally {
            setLoadingItemPanel(false)
        }
    }

    return (
        <LoadingIndicator loaded={!loadingItemPanel}>
            <Panel
                style={itemPanelStyle}
                titlePage={'Cargos'}
                setUpdating={setUpdating}
                setInserting={setInserting}
                inserting={inserting}
                updating={updating}
                enableEdit={true}
                canEdit={rolesIdSelected && rolesIdSelected.length === 1 && registrationIdsSelected && registrationIdsSelected.length === 1}
                putFunction={putItem}
                enableNewRecord={true}
                canNewRecord={registrationIdsSelected && registrationIdsSelected.length === 1}
                postFunction={postItem}
                canViewCRUD={true}
                readOnly={false}
                recordsSelected={rolesIdSelected}
                viewOnlyOneRecordCRUD={true}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                dataListedAttributes={attributesDetailItemPanel}
                attributeList={attributeList}
                onUpdateIdSelected={setRolesIdSelected}
            >
                {getItemPanelListOrDetail()}
            </Panel>
        </LoadingIndicator>
    );

}
export default Role;